<!-- pc端 邀请公司-启翼邀请码 -->
<template>
  <div class="administrator">
    <!-- 中部表格 -->
    <div class="bottom_stept">
      <div v-if="active == 1" class="center_card">
        <div class="card_title">
          <span>{{info.orgName}}</span>的<span>{{info.staffName}}</span>邀请您成为太行启翼推广员，请您验证手机号。
        </div>        
        <div class="LoginPhone">
          <div class="input">
            <div class="input_name"><span class="Required">*</span>手机号</div>
            <el-input
              v-model="phone"
              placeholder="必填"
              @input="phoneInput"
            ></el-input>
          </div>
          <div class="input">
            <div class="input_name"><span class="Required">*</span>验证码</div>
            <el-input v-model="pohoneCode" placeholder="必填" class="name_getcode">
              <template slot="append">
                <div class="input_name_in" @click="getCode" v-if="!count">
                  获取验证码
                </div>
                <div class="input_name_in" v-if="count">
                  {{ count }}秒后重发
                </div>
              </template>
            </el-input>
          </div>
          
          <div class="protocol_x">
            <el-checkbox v-model="isAgreeProtocol"></el-checkbox>
            <span class="txt_agree">同意</span><span class="txt_protocol" @click="toProtocolPage">《线上推广人员协议规范》</span>
          </div>

          <div class="login_button">
            <div :class="pohoneCode && phone && isAgreeProtocol ? 'button' : 'button_no'" @click="confirmPhone1">
              确认
            </div>
          </div>
        </div>
      </div>

      <div v-if="active == 2" class="center_card">
        <div class="LoginPhone">
          <div class="company_x">
            <div class="top">
              <span class="title">选择组织</span>
            </div>
            <div class="company_list">
              <div class="company_desc" v-for="item in companyList" :key="item.companyId" @click="chooseCompany(item.companyId)">
                <el-avatar shape="square">{{ item.companyName ? item.companyName.slice(0, 1) : ""}}</el-avatar>
                <span class="txt_name">{{ item.companyName }}</span>
                <span class="right_icon" v-if="item.companyType == 0">维保单位</span>
                <span class="right_icon" v-else-if="item.companyType == 1">使用单位</span>
                <span class="right_icon" v-else-if="item.companyType == 2">监管单位</span>
                <span class="right_icon" v-else-if="item.companyType == 3">保险单位</span>
              </div>
            </div>
          </div>
          <div class="login_button">
            <div class="button" @click="cancelCompany">
              取消
            </div>
          </div>
        </div>
      </div>

      <div v-if="active == 3" class="center_card">
        <div class="LoginPhone suss_msg">
          <div>
            您已成为太行启翼推广员！
          </div>
          <div class="txt_msg">
            快登录“<span>太行启翼</span>”平台，查看属于自己的推广码吧！
          </div>
          <div class="login_button">
            <div class="button" @click="toLoginQiyi">进入平台</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template> 

<script>
import { phoneverifyCode, addLevelTwo } from "../../../api/api";
import { checkPhone } from '@/utils/tools';

export default {
  name: "subMemberPc",
  props: ['info'],
  components: {},
  data() {
    return {
      // 表单
      phone: "", // 手机号
      pohoneCode: "", // 验证码
      isAgreeProtocol: false,
      // 步骤条
      active: 1,
      // 验证码
      timer: null,
      count: null,
      // 公司列表
      companyList: [],
      qiyiToken: "",
    };
  },
  mounted () {
    console.log('拿到什么了', this.info)
  },
  methods: {
    // 手机号
    phoneInput() {
      // 只能输入数字
      this.phone = this.phone.replace(/[^0-9.]/g, "");
    },
    // 点击获取验证码
    getCode() {
      if (checkPhone(this.phone)) {
        let params = {
          phone: this.phone,
          type: "Register",
        };
        phoneverifyCode(params).then((res) => {
          if (res.code == 200) {
            this.countdown();
          }
        });
      } else {
        this.$notify.error({
          title: "错误",
          message: "手机号输入有误，请重新输入！",
        });
      }
    },
    // 60秒倒计时，验证码请求成功后开始
    countdown() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count -= 1;
          } else {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    // 服务协议
    toProtocolPage() {
      // 新窗口打开
      window.open("/package/promotionService", "_blank");
    },
    // 提交手机信息
    async confirmPhone1() {
      if(!this.phone || !this.pohoneCode || !this.isAgreeProtocol) {
        return;
      }

      let res = await addLevelTwo({
        phone: this.phone,
        code: this.pohoneCode,
        // 一级推广员信息
        promotionId: this.info.promotionId,
        staffName: this.info.staffName,
      })
      if (res.code == 200) {
        // type 页面类型 0返回公司列表 1只有一个公司或者选中了一个公司 2无公司
        if(res.data.type === 1 || res.data.type === 2) {
          // 只有一个公司时后台默认选中 直接成功，没有过公司 直接成功
          if(res.data.promotionType == 1) {
            this.$notify.success({
              title: "提示",
              message: "您已经是推广员了",
            });
          } else {
            this.$notify.success({
              title: "成功",
              message: res.msg,
            });
          }
          
          // pc可以免登录跳转到启翼
          this.qiyiToken = res.data.token;
          this.active = 3;
        } else {          
          // 显示公司组织列表
          this.companyList = res.data.companyList;
          this.active = 2;
        }
      }
    },
    // 公司列表
    async chooseCompany(companyId) {
      if(!this.phone || !this.pohoneCode || !companyId) {
        return;
      }

      let res = await addLevelTwo({
        phone: this.phone,
        // 一级推广员信息
        promotionId: this.info.promotionId,
        staffName: this.info.staffName,
        companyId: companyId
      })
      if (res.code == 200) {
        if(res.data.promotionType == 1) {
          this.$notify.success({
            title: "提示",
            message: "您已经是推广员了",
          });
        } else {
          this.$notify.success({
            title: "成功",
            message: res.msg,
          });
        }

        // pc可以免登录跳转到启翼
        this.qiyiToken = res.data.token;
        this.active = 3;
      }
    },
    cancelCompany() {
      this.companyList = [];
      this.active = 1;
    },
    // 进入平台
    toLoginQiyi() {
      if(this.qiyiToken) {
        // 如果拿到了token 就免登录跳转到启翼
        let url = process.env.VUE_APP_BUSINESS + "/#/home?ump1=" + this.qiyiToken;
        window.open(url);
      } else {
        // 如果没有获取到token 就跳转到启翼的登录页
        window.open(process.env.VUE_APP_BUSINESS + "/#/login/qrcode");
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.administrator {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .LoginPhone :deep(.el-input-group__append, .el-input-group__prepend) {
    background-color: #fff !important;
    color: #b7282d;
  }

  .LoginPhone
    :deep(.el-input-group__append:focus, .el-input-group__prepend:focus) {
    user-select: none !important;
    cursor: pointer !important;
  }

  .bottom_stept {
    margin-top: 1.5rem;
    margin-bottom: 6.25rem;
    width: 55rem;
    min-height: 28.75rem;
    background: #ffffff;
    box-shadow: 0.375rem 0.375rem 0.75rem 0.125rem rgba(0, 0, 0, 0.16),
      -0.375rem -0.375rem 0.75rem 0.125rem rgba(0, 0, 0, 0.16);
    border-radius: 1rem;
    background-image: url("../../../assets/IMG/login/bg_ele.png");
    background-repeat: no-repeat;
    background-position: right 0rem bottom 0rem;
    .center_card {
      height: 100%;
      padding: 1.25rem;
      box-sizing: border-box;
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      justify-content: center;
      .card_title {
        margin-bottom: 20px;
        span {
          color: #b7282d;
        }
      }      
      .LoginPhone {
        width: 35%;
        .input {
          position: relative;
          padding: 1.25rem 0 0.625rem 0;
          .input_name {
            z-index: 5;
            position: absolute;
            color: #999999;
            font-weight: 400;
            font-size: 1rem;
            line-height: 1.375rem;
            background: #fff;
            left: 5%;
            top: 0.375rem;
          }

          .input_name_in {
            width: 100%;
            height: 100%;
            user-select: none;
            cursor: pointer;
          }
        }
        .erro {
          user-select: none;
          font-weight: 400;
          font-size: 0.75rem;
          line-height: 1.0625rem;
          color: #f84638;
        }

        // 服务协议
        .protocol_x {
          margin-top: 3.75rem;
          font-size: 14px;
          text-align: center;
          .txt_agree {
            margin-left: 8px;
          }
          .txt_protocol {
            color: #1677ff;
            cursor: pointer;
          }
        }

        // 选择组织
        .company_x {
          .top {
            width: 100%;
            text-align: center;
            padding-bottom: 16px;
            border-bottom: 1px solid #f5f5f5;

            .title {
              position: relative;
              color: #b7282d;
              font-weight: bold;

              &::after {
                content: "";
                width: 12px;
                height: 2px;
                background: #b7282d;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                right: -20px;
              }

              &::before {
                content: "";
                width: 12px;
                height: 2px;
                background: #b7282d;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                left: -20px;
              }
            }
          }
          .company_list {
            width: 100%;
            height: 350px;
            overflow-y: scroll;
            .company_desc {
              display: flex;
              margin-bottom: 10px;
              padding: 10px;
              align-items: center;
              cursor: pointer;
              width: 100%;
              border-radius: 4px;
              box-sizing: border-box;
              background: #ededed;
              align-items: center;
              position: relative;
              &.checked {
                border: 1px solid #b7282d;
                &:hover {
                  background: #ededed;
                }
              }
              &:hover {
                background: #dfeeff;
              }
              .txt_name {
                margin-left: 10px;
                flex: 1;
              }
              .right_icon {
                position: absolute;
                top: 0;
                right: 0;
                border-radius: 0 4px 0 4px;
                font-size: 12px;
                padding: 0 6px;
                height: 20px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #b7282d;
                background: rgba(183, 40, 45, 0.09);
              }
            }
          }   
        }

        
        // 公共按钮
        .login_button {
          margin-top: 10px;
          user-select: none;
          display: flex;
          align-items: center;
          justify-content: center;

          .button,
          .button_no {
            margin-right: 0.625rem;
            cursor: pointer;
            width: 4rem;
            height: 2rem;
            border-radius: 0.25rem;
            color: #ffffff;
            font-size: 0.75rem;
            line-height: 1.25rem;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .button {
            background: #b7282d;
          }
          .button_no {
            background: #ccc;
          }
        }

        .avatar-uploader {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .avatar-uploader .el-upload {
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }
        .avatar-uploader-icon {
          font-size: 1.75rem;
          color: #8c939d;
          width: 5.5rem;
          height: 5.5rem;
          line-height: 5.5rem;
          text-align: center;
          border: 0.0625rem dashed #ccc;
          border-radius: 0.375rem;
        }
        .avatar {
          width: 5.5rem;
          height: 5.5rem;
          display: block;
        }
      }
      // 成功页面
      .suss_msg {
        width: 100%;
        font-weight: 400;
        font-size: 1.4rem;
        color: #333333;
        margin-top: 50px;
        text-align: center;
        .txt_msg {
          font-size: 1rem;
          margin-top: 20px;
          span {
            color: #b7282d;
          }
        }
      }      
    }
  }
}
</style>